import { AI_PRODUCT_NAME } from "@bafe/ui";
import { type FormEvent, useState } from "react";

export function KeyAi() {
	const [asked, setAsked] = useState(false);

	function onSubmit(event: FormEvent<HTMLFormElement>) {
		event.preventDefault();
		setAsked(true);
	}

	return (
		<div className="card">
			<h2>{AI_PRODUCT_NAME}</h2>
			<p className="sub">Ask about this workspace. Mail, Hub, Site and billing stay in one place.</p>
			<form className="ai-ask" onSubmit={onSubmit}>
				<label htmlFor="key-ai-ask">Question</label>
				<textarea id="key-ai-ask" name="ask" rows={4} placeholder="Ask Key AI" />
				<div className="form-actions">
					<button type="submit" className="btn">
						Ask
					</button>
				</div>
			</form>
			{asked && <p className="empty">Key AI is not connected on this workspace yet.</p>}
		</div>
	);
}
